import { createRouter, createWebHistory } from "vue-router";
import TheContainer from "@/containers/TheContainer";

const supportedLanguages = ["fa", "ar", "en", "bn", "ur"];
const defaultLanguage = "fa";

function languageRoutes(lang) {
  return [
    {
      path: "",
      name: `${lang}-home`,
      component: () => import(`@/views/${lang}/home/HomeView.vue`),
    },
    {
      path: "asideHome",
      name: `${lang}-asideHome`,
      component: () => import(`@/views/${lang}/asideHome/index.vue`),
    },
    {
      path: "sound",
      name: `${lang}-sounds`,
      meta: { title: "صوت ها" },
      component: () => import(`@/views/${lang}/sound/index.vue`),
    },
    {
      path: "sound/:id/:soundId?/:title?",
      name: `${lang}-sound`,
      meta: { title: "صوت" },
      component: () => import(`@/views/${lang}/sound/SoundPage.vue`),
    },
    {
      path: "aboutus",
      name: `${lang}-aboutus`,
      meta: { title: "درباره ما" },
      component: () => import(`@/views/${lang}/aboutUs/index.vue`),
    },
    {
      path: "live",
      name: `${lang}-live`,
      meta: { title: "پخش زنده" },
      component: () => import(`@/views/${lang}/live/index.vue`),
    },
    {
      path: "posts",
      name: `${lang}-posts`,
      meta: { title: "اخبار" },
      component: () => import(`@/views/${lang}/posts/index.vue`),
    },
    {
      path: "posts/:id/:title?",
      name: `${lang}-blog`,
      component: () => import(`@/views/${lang}/posts/BlogPage.vue`),
    },
    {
      path: "search/:filter?",
      name: `${lang}-search`,
      meta: { title: "نتایج جستجو" },
      component: () => import(`@/views/${lang}/search/index.vue`),
    },
    {
      path: "media",
      name: `${lang}-medias`,
      component: () => import(`@/views/${lang}/media/index.vue`),
    },
    {
      path: "media/:id/:mediaId?/:title?",
      name: `${lang}-media`,
      component: () => import(`@/views/${lang}/media/MediaPage.vue`),
    },
    {
      path: "library",
      name: `${lang}-libraries`,
      component: () => import(`@/views/${lang}/library/index.vue`),
    },
    {
      path: "library/:id/:title?",
      name: `${lang}-library`,
      component: () => import(`@/views/${lang}/library/LibraryPage.vue`),
    },
    {
      path: "photo",
      name: `${lang}-photos`,
      component: () => import(`@/views/${lang}/photo/index.vue`),
    },
    {
      path: "photo/:id/:title?",
      name: `${lang}-photo`,
      component: () => import(`@/views/${lang}/photo/PhotoPage.vue`),
    },
  ];
}

const routes = [
  {
    path: "/",
    redirect: () => {
      const saved = localStorage.getItem("languageCode");
      return `/${supportedLanguages.includes(saved) ? saved : defaultLanguage}`;
    },
  },

  ...supportedLanguages.map((lang) => ({
    path: `/${lang}`,
    component: TheContainer,
    children: languageRoutes(lang),
  })),

  {
    path: "/:pathMatch(.*)*",
    redirect: () => `/${localStorage.getItem("languageCode") || defaultLanguage}`,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const lang = to.path.split("/")[1];

  if (!supportedLanguages.includes(lang)) {
    return next(`/${defaultLanguage}`);
  }

  localStorage.setItem("languageCode", lang);

  document.documentElement.lang = lang;

  next();
});

export default router;
